import IDMGlobals from '../../IDMGlobals';
//
export default class APIPublicKey {
  constructor(API) {
    this.api = API;
  }
  async get() {
    const req = this.api.newPlainRequest('GET');
    req.path = IDMGlobals.APIPath_PublicKey;
    return await req.exec();
  }
}
